import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Spinner from './index'

const Container = styled(View)`
  flex: 1;
  align-items: center;
  justify-content: center;
`

export default class CenteredSpinner extends PureComponent {
  render () {
    return (
      <Container>
        <Spinner size={this.props.size || 'large'} />
      </Container>
    )
  }
}
